import * as React from "react";
import { connect } from "react-redux";
import { match } from "react-router-dom";
import { mapDispatchToProps } from "../../redux/actions";
import { isEmptyObject } from "../../utilities/helpers";
import { callGetEndpoint } from "../../api-calls/readApiService";
import TempsSystemCoilInputs from "./TempsSystemCoilInputs";

// expected props
interface IProps {
  updateRedux: any;
  match: match<any>;
}
// local state
interface IState {
  componentData: any;
}

class TempsSystemCoils extends React.Component<IProps, IState> {
  public state: IState = {
    componentData: null
  };

  async componentDidMount() {
    const { projectId, unitId } = this.props.match.params;
    this.props.updateRedux('UPDATE_DISPLAY', { showLoader: true });
    const result = await callGetEndpoint("readapi/GetAllCoilInputValues", projectId, unitId);
    this.props.updateRedux('UPDATE_DISPLAY', { showLoader: false });
    if (!isEmptyObject(result)) {
      this.setState({
        componentData: result
      });
    }
  }

  public render() {
    const componentData = this.state.componentData;
    if (isEmptyObject(componentData)) {
      return null;
    }

    const displayFields = componentData.uiDataContainer.displayFields;
    
    return (

        <div>
            {displayFields.showPreHeatHotWaterCoil ? (
            <TempsSystemCoilInputs
                title="Pre Heat Hot Water Fluid Conditions"
                targetVertex="PreHeatHotWaterCoilInputs"
                componentData={componentData}
                userInputs={componentData.uiDataContainer.preHeatHotWaterCoilInputs}
                match={this.props.match}
            />
            ) : null}
            {displayFields.showHotWaterCoil ? (
            <TempsSystemCoilInputs
                title="Hot Water Fluid Conditions"
                targetVertex="HotWaterCoilInputs"
                componentData={componentData}
                userInputs={componentData.uiDataContainer.hotWaterCoilInputs}
                match={this.props.match}
            />
            ) : null}
            {displayFields.showChilledWaterCoil ? (
            <TempsSystemCoilInputs
                title="Chilled Water Fluid Conditions"
                targetVertex="ChilledWaterCoilInputs"
                componentData={componentData}
                userInputs={componentData.uiDataContainer.chilledWaterCoilInputs}
                match={this.props.match}
            />
            ) : null}
            <div className="spec-field-spacer2"></div>
            <div className="spec-field-spacer1"></div>
        </div>
    );
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(TempsSystemCoils);
